import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('theme', { $theme: 'theme' })
  },
  methods: {
    ...mapActions('theme', ['toggleTheme'])
  }
}
